import { driver } from 'driver.js';

document.addEventListener('DOMContentLoaded', () => {
    const tourGuide = document.querySelector('#tourguide');

    if (tourGuide) {
        let assetsDir = '/ar/assets';
        if (window?.location.host.startsWith('localhost:300') || window?.location.hostname.endsWith('.luminary.space')) {
            assetsDir = '/assets';
        }
        const tourGuideHeadingStepsDesktop = [
            {
                // popup 2
                element: '.header .desktop-header .desktop-header-item-wrapper',
                popover: {
                    title: 'Navigation',
                    description: `
                    There are two ways to navigate various sections of the report:
                    <ol>
                    <li><b>Use the Navigation menu</b>. Click on a Tab to switch between the sections, or</li>
                    <li><b>Scroll down</b> the page and click on one of the three screening program boxes.</li>
                    <img src="${assetsDir}/images/instructions/scroll-to-screening-programs.gif" />
                    `,
                },
                onHighlighted: () => {
                    window.scrollBy({ top: 1, left: 0 });
                },
            }
        ];

        const tourGuideHeadingStepsMobile = [
            {
                // popup 2
                element: '.header .mobile-header .mobile-header-item-wrapper',
                popover: {
                    title: 'Navigation',
                    description: `
                    There are two ways to navigate various sections of the report:
                    <ol>
                    <li><b>Use the Navigation menu</b>. Click on a Tab to switch between the sections, or</li>
                    <li><b>Scroll down</b> the page and click on one of the three screening program boxes.</li>
                    <img src="${assetsDir}/images/instructions/scroll-to-screening-programs.gif" />
                    `,
                },
                onHighlighted: () => {
                    const doc = document.documentElement;
                    const top = (window?.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
                    console.info(top);
                    if (top < 10) {
                        window.scrollBy({ top: 1, left: 0 });
                    } else {
                        window.scrollTo({ top: 0, left: 0 });
                    }
                },
            }
        ];

        const tourGuideRestSteps = [
            {
                element: '#guide-step-4 .container .swiper',
                popover: {
                    title: 'Key insights',
                    description: 'These are \'snapshots\' from each screening program - they may show how the program is tracking against targets, or highlight a trend in the overall data, or an increase/decrease in a particular age group, or any other important change observed in the current reporting year.',
                },
            },
            {
                element: '#guide-step-5 .container',
                popover: {
                    title: 'Screening Programs - landing pages',
                    description: 'Each screening program section includes an introduction, which outlines the eligible population.',
                },
            },
            {
                element: '#guide-step-6 .container .dropdown-buttons-container',
                popover: {
                    title: 'Focus area select',
                    description: 'Select a focus area by clicking one of these buttons. Active focus areas will be highlighted in blue.',
                },
                onHighlighted: () => {
                    window.scrollBy({ top: 1, left: 0 });
                },
            },
            {
                element: '#chart-instruction-crs .ar-chart-split .splitter-year select',
                popover: {
                    title: 'Data filters',
                    description: 'Show a single year of data by selecting from the \'Year\' dropdown. Other reports may also show a \'Time Period\' dropdown.',
                },
            },
            {
                element: '#chart-instruction-crs .ar-chart-split .splitter-compare-by select',
                popover: {
                    title: 'Data Filters - dropdown options',
                    description: `You can also choose what you want to see on the interactive chart.<br />
                    <img src="${assetsDir}/images/instructions/compare-dropdown.gif" />`,
                },
            },
            {
                element: '#chart-instruction-crs .ar-chart-type',
                popover: {
                    title: 'Visualisation Types',
                    description: `Choose your own adventure!<br />
        You will notice that, as you select one of the three Visualisation options (Compare, Map, or Trend), the data categories on the right also change. 
        These are the options you have for stratifying (or filtering) the data.
        <img src="${assetsDir}/images/instructions/visualisation-types.gif" />
        <ul>
        <li>
        <b>Compare</b> shows a horizontal bar chart. Under the heading 'Data For', 
        you can stratify the data by choosing from the dropdowns:
        'Year' and 'Compare By' (by Sex, Age Group, PHN, or LPHU).
        Under the heading 'Include', you can filter the data further by 'Sex' (All, Male, Female).
        </li>
        <li>
        <b>Map</b> shows the data on a map of Victoria. Under the heading 'Data For', 
        you can stratify the data to display on the map by choosing from the dropdowns:
        'Year' and 'Region Type' (by LGA, PHN, LPHU). 
        Under the heading 'Include', you can filter the data further by 'Sex' (All, Male, Female).
        </li>
        <li>
        <b>Trend</b> show the data over a 6-year period. Under the heading 'Data For', 
        you can stratify the data by 'Region Type' (by LGA, LPHU, PHN).
        Under the heading 'Include', filter the data further by: 'Regions' 
        (note that the dropdowns will change according to the selection in 'Region Type') and 'Sex' (All, Male, Female).
        </li>
        </ul>
                    `,
                },
                onHighlighted: () => {
                    window.scrollBy({ top: 1, left: 0 });
                },
            },
            {
                element: '#chart-instruction-crs .ar-chart-body canvas',
                popover: {
                    title: 'Hover to see point data values',
                    description: `Hovering over a point in each bar chart displays the value for that data point. Try it yourself now! `,
                },
            },
            {
                element: '#guide-step-6 .find-more-links',
                popover: {
                    title: 'Trend bar graph point data value',
                    description: `Supporting information for the visualisations are attached as follows:<br />
        <b>Interpretation</b> - Provides a definition of the focus area and guidance on how to interpret the data.<br />
        <b>Technical Notes</b> - Detailed information on the definition of the focus area selected, data sources, data calculation and validation processes utilised, among others.<br />
        <b>Data Tables</b> - Can be accessed and downloaded as an Excel file.`,
                },
                onHighlighted: () => {
                    window.scrollBy({ top: 1, left: 0 });
                },
            }
        ];

        const tourGuideManualSteps = [
            ...tourGuideHeadingStepsDesktop,
            ...tourGuideRestSteps
        ];

        const tourGuideManualStepsMobile = [
            ...tourGuideHeadingStepsMobile,
            ...tourGuideRestSteps
        ];

        if (!window.tourGuide) {
            window.tourGuide = driver({
                showProgress: true,
                smoothScroll: true,
                popoverClass: 'instructions-popover',
                onDestroyed: () => {
                    window.scrollTo({
                        behavior: 'smooth',
                        left: 0,
                        top: 0,
                    });
                    const instructionContent = document.querySelectorAll('.instruction-content');

                    instructionContent.forEach(content => {
                        content.classList.remove('in-progress');
                    });
                },
            });
        }

        const startTourButton = document.querySelector('#tourguide-start-tour');
        if (startTourButton) {
            startTourButton.addEventListener('click', () => {
                if (window && window.tourGuide) {
                    window.tourGuide.setSteps(tourGuideManualSteps);

                    const instructionContent = document.querySelectorAll('.instruction-content');
                    instructionContent.forEach(content => {
                        content.classList.add('in-progress');
                    });

                    window.tourGuide.drive();
                }
            });
        }

        const startTourButtonMobile = document.querySelector('#tourguide-start-tour-mobile');
        if (startTourButtonMobile) {
            startTourButtonMobile.addEventListener('click', () => {
                if (window && window.tourGuide) {
                    window.tourGuide.setSteps(tourGuideManualStepsMobile);

                    const instructionContent = document.querySelectorAll('.instruction-content');
                    instructionContent.forEach(content => {
                        content.classList.add('in-progress');
                    });

                    window.tourGuide.drive();
                }
            });
        }
    }
});
